import React, { useState, useEffect, useContext } from "react";
import ProveedorContext from "../context/ProveedorContext";
import CartContext from "../context/CartContext";
import { cargaProveedores, cargaProductos } from "../services/proveedores.jsx";
import BuscadorCbo from "./buscadorCbo.jsx";
import Swal from "sweetalert2";

export default function Buscador({ actualizar, setactualizar, actualizarProveedor, setActualizarProveedor }) {
  const [cbo, setCbo] = useState([]);
  const [productos, setProductos] = useState([]);
  const { proveedorContext } = useContext(ProveedorContext);
  const { setCart, cart } = useContext(CartContext);
  const [productosCargados, setProductosCargados] = useState(false);
  const [idProveedor, setIdProveedor] = useState(0);
  const [proveedorSeleccionado, setProveedorSeleccionado] = useState("");

  useEffect(() => {
    cargaProveedores()
      .then((proveedores) => {
        setCbo(proveedores);
        if (proveedorContext.length === 1) {
          setProveedorSeleccionado(String(proveedorContext[0].id));
          renderProductos(proveedorContext[0].id, true);
        } else if (proveedores.length > 0) {
          setProveedorSeleccionado(String(proveedores[0].id));
          renderProductos(proveedores[0].id, false);
        }
      })
      .catch((error) => console.error(error));
    setActualizarProveedor(false);
  }, [actualizarProveedor]);

  const renderProductos = (id, cargaAntigua) => {
    setProductosCargados(false);
    cargaProductos(id)
      .then((product) => {
        if (cargaAntigua) {
          cart.forEach((itemCarrito) => {
            const productoIndex = product.findIndex(
              (producto) => producto.id_producto === itemCarrito.id_producto
            );
            if (productoIndex !== -1) {
              product[productoIndex].cantidad = itemCarrito.cantidad;
            }
          });
          setProductos(product);
        } else {
          setCart([]);
          setProductos(product);
        }
        setProductosCargados(true);
      })
      .catch((error) => console.error(error))
      .finally(() => setIdProveedor(id));
  };

  useEffect(() => {
    if (actualizar) {
      if (proveedorSeleccionado) renderProductos(proveedorSeleccionado, true);
      setactualizar(false);
    }
  }, [actualizar]);

  useEffect(() => {
    if (!productosCargados) {
      Swal.fire({
        title: "Cargando Productos",
        html: '<div class="flex justify-center"><div class="w-8 h-8 border-4 border-pons-500 border-t-transparent rounded-full animate-spin"></div></div>',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: "transparent",
        backdrop: false,
      });
    } else {
      Swal.close();
    }
  }, [productosCargados]);

  return (
    <div className="space-y-4">
      <div className="card p-4">
        <label className="label-field text-base">Seleccione el Proveedor:</label>
        <select
          onChange={(e) => {
            setProveedorSeleccionado(e.target.value);
            renderProductos(e.target.value);
          }}
          className="select-field"
          id="cboProveedor"
          value={proveedorSeleccionado}
        >
          {cbo.map((option) => (
            <option
              key={option.id}
              value={option.id}
            >
              {option.nombre}
            </option>
          ))}
        </select>
      </div>

      {!productosCargados ? (
        <div className="flex items-center gap-3 justify-center py-12">
          <div className="w-6 h-6 border-4 border-pons-500 border-t-transparent rounded-full animate-spin"></div>
          <p className="text-ink-muted font-medium">
            Cargando productos<span className="loading-dots">...</span>
          </p>
        </div>
      ) : productos.length === 0 ? (
        <div className="card p-8 text-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-ink-light mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
          </svg>
          <p className="text-ink font-semibold">El Proveedor No Contiene Productos</p>
        </div>
      ) : (
        <BuscadorCbo data={productos} proveedor={idProveedor} />
      )}
    </div>
  );
}
